import { Navigate } from 'react-router-dom';
import { isUserAuthenticated } from '../utils/auth';

const ProtectedComponent = ({ component } : any) => {
  return isUserAuthenticated() ? component : <Navigate to="/login" replace={true} />;
};

export default ProtectedComponent;